import type { ViewRenderOffer, ViewRenderRequest, ViewRenderResult } from '@aibuild/model-viewer';
import client from './client';
import { axiosErrorMessage } from './errors';
import { VIEW_RENDER_API } from './routes';

export async function getViewRenderOffer(): Promise<ViewRenderOffer> {
  const { data } = await client.get<ViewRenderOffer>(`${VIEW_RENDER_API}/offer`);
  return data;
}

/** Renders the view with an image model; charged, and takes up to a couple of minutes. */
export async function renderView(request: ViewRenderRequest, signal?: AbortSignal): Promise<ViewRenderResult> {
  try {
    const { data } = await client.post<ViewRenderResult>(VIEW_RENDER_API, request, { signal });
    return data;
  } catch (err) {
    throw new Error(axiosErrorMessage(err, ''), { cause: err });
  }
}
